import React from 'react';

import InputField from '../Input/InputField';
import { normalizeCnpj, formatCnpjAlphanumeric } from '../../../../helpers/utils/cnpj.utils';

function AlphanumericCnpjInput({
  inputRef, onChange, name, value, ...other
}) {
  function handleChange(event) {
    const raw = normalizeCnpj(event.target.value).slice(0, 14);
    onChange({ target: { value: raw, name } });
  }

  return (
    <input
      {...other}
      ref={inputRef}
      name={name}
      value={formatCnpjAlphanumeric(value || '')}
      onChange={handleChange}
      maxLength={18}
    />
  );
}

function AlphanumericMaskField({ inputProps, name, ...props }) {
  return (
    <InputField
      {...props}
      inputProps={{ name, ...inputProps }}
      inputComponent={AlphanumericCnpjInput}
    />
  );
}

export default React.memo(AlphanumericMaskField);
